import { render, staticRenderFns } from "./SalesPersonEditView.vue?vue&type=template&id=cad63d5c"
import script from "./SalesPersonEditView.vue?vue&type=script&lang=js"
export * from "./SalesPersonEditView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports